import Full from '../layout/Full.vue';
import Distributors from '../pages/distributors/Index.vue';
import Laboratories from '../pages/laboratories/Index.vue';
import Movies from '../pages/movies/Index.vue';
import Movie from '../pages/movie/Index.vue';

export default {
  path: '/',
  redirect: '/',
  component: Full,
  children: [
    {
      name: 'distributors',
      path: 'distributors/:distributorId?',
      component: Distributors,
      meta: {
        auth: true,
        title: 'Прокатчики',
        breadcrumbs: [
          { name: 'Прокат' },
          { name: 'Дистрибьюторы' },
          { name: 'Прокатчики' },
        ],
        permissions: ['all'],
      },
    },
    {
      name: 'laboratories',
      path: 'laboratories/:labId?',
      component: Laboratories,
      meta: {
        auth: true,
        title: 'Лаборатории',
        breadcrumbs: [
          { name: 'Прокат' },
          { name: 'Дистрибьюторы' },
          { name: 'Лаборатории' },
        ],
        permissions: ['all'],
      },
    },
    {
      name: 'movies',
      path: 'movies/',
      component: Movies,
      meta: {
        auth: true,
        title: 'Фильмы',
        breadcrumbs: [
          { name: 'Прокат' },
          { name: 'Фильмы' },
        ],
        permissions: ['all'],
      },
    },
    {
      name: 'movie',
      path: '/movies/:movieId?/:tab?',
      component: Movie,
      meta: {
        auth: true,
        title: 'Просмотр фильма',
        breadcrumbs: [
          { name: 'Прокат' },
          { name: 'Фильмы' },
        ],
      },
      permissions: ['all'],
    },
  ],
};
